export const getMimeType = (fileName: string): string => {
  const fileExtension = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();

  const mimeTypes: { [key: string]: string } = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    pdf: 'application/pdf',
    gif: 'image/gif',
  };

  return mimeTypes[fileExtension] || 'application/octet-stream';
};

export const getFileExtension = (mimeType: string): string => {
  // Clean the MIME type string
  const cleanMime = mimeType
    .replace(/^data:/, '')    // Remove 'data:' if present
    .split(';')[0]            // Remove anything after ';' like ';base64'
    .trim().toLowerCase();

  // Map of MIME types to extensions
  const mimeToExt: { [key: string]: string } = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'application/pdf': 'pdf',
    'image/gif': 'gif',
  };

  return mimeToExt[cleanMime] || 'bin'; // 'bin' as generic fallback
};
